import React from 'react';

export const DeleteImage = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.57607 4.57582C4.77142 4.38054 5.03632 4.27084 5.31253 4.27084C5.58874 4.27084 5.85365 4.38054 6.04899 4.57582L10 8.52686L13.9511 4.57582C14.0472 4.47633 14.1621 4.39697 14.2892 4.34238C14.4163 4.28779 14.553 4.25905 14.6913 4.25785C14.8296 4.25665 14.9668 4.28301 15.0948 4.33538C15.2228 4.38776 15.3391 4.4651 15.4369 4.56291C15.5347 4.66071 15.6121 4.77702 15.6644 4.90504C15.7168 5.03305 15.7432 5.17022 15.742 5.30853C15.7408 5.44684 15.712 5.58353 15.6574 5.71062C15.6028 5.8377 15.5235 5.95265 15.424 6.04874L11.4729 9.99978L15.424 13.9508C15.6137 14.1473 15.7187 14.4104 15.7164 14.6835C15.714 14.9567 15.6044 15.2179 15.4113 15.411C15.2182 15.6042 14.9569 15.7137 14.6838 15.7161C14.4107 15.7185 14.1475 15.6135 13.9511 15.4237L10 11.4727L6.04899 15.4237C5.85253 15.6135 5.5894 15.7185 5.31628 15.7161C5.04316 15.7137 4.7819 15.6042 4.58876 15.411C4.39563 15.2179 4.28608 14.9567 4.2837 14.6835C4.28133 14.4104 4.38633 14.1473 4.57607 13.9508L8.52712 9.99978L4.57607 6.04874C4.38079 5.8534 4.27109 5.58849 4.27109 5.31228C4.27109 5.03607 4.38079 4.77116 4.57607 4.57582Z"
                fill="#252733"
            />
        </svg>
    );
};
